module.exports = __webpack_public_path__ + "img/b1.762bad73.png";